import { CustomLayerProps } from '@nivo/line'
import { line } from 'd3'
import { Line as D3Line } from 'd3-shape'

import { NULL_SERIES_PREFIX } from './helpers'

const CustomDashedLineLayer = ({ series }: CustomLayerProps) => {
  const lineGen: D3Line<{ x: number; y: number }> = line<{ x: number; y: number }>()
    .x((d) => d.x)
    .y((d) => d.y)

  return (
    <g>
      {series.map(({ id, data }) => {
        if (`${id}`.includes(NULL_SERIES_PREFIX)) {
          const points: { x: number; y: number }[] = []
          data.forEach((d) => {
            if (d.data.y) {
              points.push({
                x: d.position.x,
                y: d.position.y,
              })
            }
          })

          return (
            <path
              key={id}
              fill="none"
              stroke="#fff"
              strokeWidth={2}
              strokeDasharray="6, 6"
              d={lineGen(points) ?? undefined}
            />
          )
        }
        return null
      })}
    </g>
  )
}

export { CustomDashedLineLayer }
